$(document).on("turbolinks:load", function () {
  if (!$("body").hasClass("controller-leagues-round_types-overrides")) return;

  $(".round-date-input").mask("00/00/0000").pickadate();

  function formatDate(date) {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }

  function parseDate(str) {
    const [month, day, year] = str.split("/");
    return new Date(year, month - 1, day);
  }

  $("#shift-dates-forward").on("click", function () {
    $(".round-date-input").each(function () {
      const currentDate = parseDate($(this).val());
      const newDate = new Date(currentDate.setDate(currentDate.getDate() + 7));
      $(this).val(formatDate(newDate));
    });
  });

  $("#shift-dates-backward").on("click", function () {
    $(".round-date-input").each(function () {
      const currentDate = parseDate($(this).val());
      const newDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
      $(this).val(formatDate(newDate));
    });
  });

  function shiftTees(forward = true) {
    const menTees = $("select[name*='[men_tee_id]']").toArray();
    const womenTees = $("select[name*='[women_tee_id]']").toArray();

    const shift = forward ? 1 : -1;

    function rotate(arr) {
      const values = arr.map((el) => $(el).val());
      const newValues = values.map((_, i) => values[(i - shift + values.length) % values.length]);
      arr.forEach((el, i) => $(el).val(newValues[i]).trigger("change"));
    }

    rotate(menTees);
    rotate(womenTees);
  }

  $("#shift-tees-forward").on("click", () => shiftTees(true));
  $("#shift-tees-backward").on("click", () => shiftTees(false));
});
